import { applyMiddleware, compose } from "redux";
import { thunk } from 'redux-thunk';
import { createLogger } from "redux-logger";
import promise from "redux-promise-middleware";
import { loadingBarMiddleware } from "react-redux-loading-bar";
import { APP_ENV } from "Config";
import { getHistory } from "../router/getHistory";
import { createReduxHistoryContext } from "redux-first-history";

const history = getHistory();

const { routerMiddleware } = createReduxHistoryContext({
  history,
});
const composeEnhancers =
  APP_ENV === "production"
    ? compose
    : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// PROD Middlewares
const prodMiddlewares = [
  routerMiddleware,
  thunk,
  promise,
  loadingBarMiddleware(),
];

// DEV Middlewares
const devMiddlewares = [...prodMiddlewares, createLogger()];

const middlewares = APP_ENV === "v2" ? prodMiddlewares : devMiddlewares;

export const createEnhancer = () =>
  composeEnhancers(applyMiddleware(...middlewares));
